export const actionTypes = {
    LOAD_HOUSE: 'LOAD_HOUSE',
    LOAD_GAME: 'LOAD_GAME',
    LOAD_MULTIPLE_GAMES: 'LOAD_MULTIPLE_GAMES',
    DELETE_GAME: 'DELETE_GAME',
    ADD_MEMBER: 'ADD_MEMBER',
    UPDATE_MEMBER: 'UPDATE_MEMBER',
    ADD_GAME: 'ADD_GAME',
    SORT_PLAYERS: 'SORT_PLAYERS',
    ADD_PLAYER_REQUEST: 'ADD_PLAYER_REQUEST',
    ADD_PLAYER_SUCCESS: 'ADD_PLAYER_SUCCESS',
    ADD_PLAYER_FAILURE: 'ADD_PLAYER_FAILURE',
    REMOVE_PLAYER_REQUEST: 'REMOVE_PLAYER_REQUEST',
    REMOVE_PLAYER_SUCCESS: 'REMOVE_PLAYER_SUCCESS',
    REMOVE_PLAYER_FAILURE: 'REMOVE_PLAYER_FAILURE',
    UPDATE_PENDING_TRANSACTION: 'UPDATE_PENDING_TRANSACTION',
    CREATE_TRANSACTION_REQUEST: 'CREATE_TRANSACTION_REQUEST',
    CREATE_TRANSACTION_SUCCESS: 'CREATE_TRANSACTION_SUCCESS',
    CREATE_TRANSACTION_FAILURE: 'CREATE_TRANSACTION_FAILURE',
    DELETE_TRANSACTION_REQUEST: 'DELETE_TRANSACTION_REQUEST',
    DELETE_TRANSACTION_SUCCESS: 'DELETE_TRANSACTION_SUCCESS',
    DELETE_TRANSACTION_FAILURE: 'DELETE_TRANSACTION_FAILURE',
    TOGGLE_TRANSACTION_STATUS: 'TOGGLE_TRANSACTION_STATUS',
    CHANGE_TRANSACTION_PAYMENT_TYPE: 'CHANGE_TRANSACTION_PAYMENT_TYPE',
    CREATE_COVER_TRANSACTION: 'CREATE_COVER_TRANSACTION',
    ADD_COVER_CANDIDATE: 'ADD_COVER_CANDIDATE',
    REMOVE_COVER_CANDIDATE: 'REMOVE_COVER_CANDIDATE',
    RESET_COVER_CANDIDATE: 'RESET_COVER_CANDIDATE',
    CLEAR_COVER_CANDIDATES: 'CLEAR_COVER_CANDIDATES',
};
